import { render } from "./AccountLayout.vue?vue&type=template&id=f8884c74"
import script from "./AccountLayout.vue?vue&type=script&lang=js"
export * from "./AccountLayout.vue?vue&type=script&lang=js"

import "./AccountLayout.vue?vue&type=style&index=0&id=f8884c74&lang=css"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__